import React from 'react';
import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import useIdleTimeout from '../../hooks/admin/useIdleTimeout';
import Sidebar from './components/Sidebar';

const AdminLayout = () => {
     const isAuthenticated = useSelector((state) => state.auth.isAuthenticated);

      useIdleTimeout(isAuthenticated ? 15 * 60 * 1000 : null);
  return (
    <div className='admin-layout'>
      <Sidebar />
      <main className='admin-content'>
        <Outlet />
      </main>
    </div>
  );
};

export default AdminLayout;
